module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-farbe-beispiel-graphit.e5ae4d80.jpeg";